import { ApolloFetchPolicy } from "shared/types/ApolloFetchPolicy"

import { useProjectsLazyQuery } from "entities/projects/graphql/queries.generated"

import { useProjectsCache } from "./useProjectsCache"

export function useLazyProjects() {
  const [fetch, { data, ...rest }] = useProjectsLazyQuery({
    fetchPolicy: ApolloFetchPolicy.NETWORK_ONLY
  })
  useProjectsCache(data?.projects)

  return {
    projects: data?.projects,
    fetch,
    ...rest
  }
}
